import { useStore as getStore } from "../../utils/useStore.js";
import modalFactory from "./modalFactory.js";
import DefaultContainer from "../../components/Structure/ModalManager/DefaultContainer.js";

const initialState = () => ({
  modal: null,
  container: DefaultContainer,
  props: {},
  modalSize: "modal",
  isAboutToClose: false,
});

const [ModalProvider, useModal, withModal] = getStore(
  modalFactory,
  initialState,
  "Modal"
);

export const modalInitState = initialState();

export { useModal, ModalProvider, withModal };

export default ModalProvider;
